export default __webpack_public_path__ + "static/media/map-full-icon.ceec3860.svg";